import { YesNoEmpty } from '@interfaces/models';
import { AccountTypes } from '@interfaces/models/account-types';
import { IndividualDesignationListedTypes } from '@interfaces/models/individual-designation-types';
import { IRADesignationListedTypes } from '@interfaces/models/ira-designation-types';
import { createAction, props } from '@ngrx/store';
import { FlowTypes, GiftingDesignationTypes } from '@shared/models';

import { TriageState } from '../../reducers/triage/triage.reducer';

export const ClearTriageState = createAction('[Triage State] Triage: Clear existing triage state');

export const UpdateClientStatusSelection = createAction(
  '[Update Client Status Selection] Triage: Update Client Status Selection',
  props<{ payload: string }>(),
);
export const UpdateSpouseStatusSelection = createAction(
  '[Update Spouse Status Selection] Triage: Update Spouse Status Selection',
  props<{ payload: string }>(),
);
export const UpdateAccountTypeSelection = createAction(
  '[Update Account Type Selection] Triage: Update Account Type Selection',
  props<{ payload: AccountTypes }>(),
);
export const UpdateIRADesignation = createAction(
  '[Update Bene Desig Selection] Triage: Update IRA Beneficiary Designation Selection',
  props<{ payload: IRADesignationListedTypes }>(),
);
export const UpdateIndividualDesignation = createAction(
  '[Update Individual Desig Selection] Triage: Update Individual Designation Selection',
  props<{ payload: IndividualDesignationListedTypes }>(),
);
export const UpdateGiftingDesignation = createAction(
  '[Update Gifting Desig Selection] Triage: Update Gifting Designation Selection',
  props<{ payload: GiftingDesignationTypes }>(),
);
export const UpdateFlowTypeSelection = createAction(
  '[Update Flow Type Selection] Triage: Update Flow Type Selection',
  props<{ payload: FlowTypes }>(),
);
export const UpdateTriageSelections = createAction(
  '[Update Triage Selection] Triage: Update Client, Spouse, and Account Type Selections',
  props<{ payload: TriageState | Partial<TriageState> }>(),
);
export const UpdateTrustTriageSelections = createAction(
  '[Update Trust Triage Selection] Triage: Update Account Type Selections, Designation, Decedent Spouse',
  props<{ payload: TriageState }>(),
);
export const UpdateIsSingleTrustee = createAction(
  '[Update Is Single Trustee] Triage: Update Is Single Trustee Selection',
  props<{ payload: YesNoEmpty }>(),
);
export const GuideContinue = createAction('[Guide Continue] Guide: Continue');
export const TriageContinue = createAction('[Triage Continue] Triage: Continue');
export const MultiTriageContinue = createAction('[Multi Triage Continue] Multi Triage: Continue');
export const GiftingSummaryContinue = createAction(
  '[Gifting Triage Continue] Gifting Triage: Continue',
);
export const InheritedIraTriageContinue = createAction(
  '[Inherited IRA Triage Continue] Inherited Ira Triage: Continue',
);
export const OverviewContinue = createAction('[Overview Continue] Overview: Continue');
